import * as React from "react";
import type { SVGProps } from "react";
const SvgStopCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9 9V8a1 1 0 0 0-1 1zm6 0h1a1 1 0 0 0-1-1zm0 6v1a1 1 0 0 0 1-1zm-6 0H8a1 1 0 0 0 1 1zm12-3a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11zm-9 9a9 9 0 0 1-9-9H1c0 6.075 4.925 11 11 11zm-9-9a9 9 0 0 1 9-9V1C5.925 1 1 5.925 1 12zm9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11zm-3 7h6V8H9zm5-1v6h2V9zm1 5H9v2h6zm-5 1V9H8v6z"
    />
  </svg>
);
export default SvgStopCircle;
